import { createFileRoute, useParams } from '@tanstack/react-router';

import { ClientExerciseReviewScreen } from '@/features/exercises/components/ClientExerciseReviewScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute(
  '/_staff/admin/workspace/clients/$clientId/exercises/$clientExerciseId',
)({
  beforeLoad: () => {
    requirePermission('engagement:read');
  },
  component: WorkspaceClientExerciseReviewRoute,
  staticData: { crumb: 'Review' },
});

function WorkspaceClientExerciseReviewRoute() {
  const { clientId, clientExerciseId } = useParams({
    from: '/_staff/admin/workspace/clients/$clientId/exercises/$clientExerciseId',
  });
  return <ClientExerciseReviewScreen clientId={clientId} clientExerciseId={clientExerciseId} />;
}
